
import { defineComponent, reactive, ref } from 'vue'
import { AddOrganization, useOrganizationModule } from '@/modules/organizations'
import OrganizationsFormFieldCompanyName from '@/components/organizations/form-fields/company-name.vue'
import OrganizationsFormFieldBusinessId from '@/components/organizations/form-fields/business-id.vue'
import OrganizationsFormFieldContactPersonName from '@/components/organizations/form-fields/contact-person-name.vue'
import OrganizationsFormFieldContactPersonEmail from '@/components/organizations/form-fields/contact-person-email.vue'
import { useFormModule } from '@/modules/_shared/forms'
import QForm from 'quasar/src/components/form/QForm.js';
import { OrganizationsRouteNames } from '@/router/routes-names'
import { useRouter, useRoute } from 'vue-router'

export default defineComponent({
    name: 'organizations-new-organization-form',
    components: {
        OrganizationsFormFieldCompanyName,
        OrganizationsFormFieldBusinessId,
        OrganizationsFormFieldContactPersonName,
        OrganizationsFormFieldContactPersonEmail
    },
    setup () {
        const { addOrganization } = useOrganizationModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const router = useRouter()
        const route = useRoute()

        const isReadonly = ref(true)

        const form = ref<QForm>()
        const organizationModel = reactive<AddOrganization>({
            companyName: '',
            businessId: '',
            contactPersonName: '',
            contactPersonEmail: ''
        })

        const sendRequest = async () => addOrganization(organizationModel)
        const moveToList = () => router.push({ name: OrganizationsRouteNames.LIST, query: { page: route.query.page } })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Organization added')
        ).then(moveToList)

        return {
            organizationModel,
            onSubmit,
            form,
            isReadonly,
            OrganizationsRouteNames,
            route
        }
    }
})
